import Handlebars from 'handlebars';
import EventHub from '~/eventHub';
import toastr from 'toastr';
import linkify from 'linkify';
import chatTemplate from '~/templates/chat.handlebars';
import chatWindowTemplate from '~/templates/chatWindow.handlebars';
import chatMessageTemplate from '~/templates/chatMessage.handlebars';
import getChatMessagesService from '~/services/chatMessagesService';
import GeneralView from '~/generalView';
import getUtilsService from '~/services/utilsService';
import imageResize from '~/services/imageResizeService';
import PrevisualView from '~/views/previsualView';
import Settings from '~/settings.js';
const CONVERSATION_LIMIT = 30;
const dateOptions = {year: '2-digit', month: 'numeric', day: 'numeric', hour: '2-digit', minute: '2-digit'};

var ChatView = GeneralView.View.extend({
	tagName: "div",
	className: 'chat',
	currentChat: undefined,
	activeNotifications: [],
	files: [],
	filesCont: 0,
	chatPage: 0,
	user: null,
	initialize: function() {
		toastr.options = {
			"closeButton": true,
			"debug": false,
			"newestOnTop": true,
			"progressBar": false,
			"positionClass": "toast-top-center",
			"preventDuplicates": false,
			"onclick": null,
			"showDuration": "300",
			"hideDuration": "1000",
			"timeOut": "5000",
			"extendedTimeOut": "1000",
			"showEasing": "swing",
			"hideEasing": "linear",
			"showMethod": "fadeIn",
			"hideMethod": "fadeOut"
		}
		
		var that = this;
		this.listenTo(EventHub, 'renderChat', () => {
			that.startUp();
		});
		
		this.listenTo(EventHub, 'logout', () => {
			$('.chat').empty();
		});
	},
	events: {
		'click #minim_chat_window':'minim',
		'click .icon_close':'close',
		'click #chat-users li':'newChat',
		'click #open-contacts':'openContacts',
		'click #close-contacts':'closeContacts',
		'keyup #contact-finder':'searchContacts',
		'click #btn-chat':'sendMessage',
		'keypress #btn-input':'sendMessageEnter',
		'change #chat-unread':'orderByUnread',
		'change #upload-chat-files':'uploadFile',
		'click #discard-all-chat-files':'discardAll',
		'click .discard-chat-file':'discardFile',
		'click #send-chat-files':'saveFiles',
		'click .chat-file':'previsual',
		'click #chat-load-more':'loadMoreMessages'
	},
	
	render: function () {
		this.startUp();
		this.user = Parse.User.current();
	},
	
	startUp: function(){
		if(Parse.User.current()){
			var permissions = getUtilsService.getprofilepermissions();
			var handlebarsTemplate = Handlebars.template(chatTemplate);
			var self = this;
			var params = {"id": Parse.User.current().id, "orderAsc":true, "orderBy":"username"};
			if (Settings.shogunmonitorapp && !permissions.accessallreports) {
				params.shogunmonitorapp = true;
			};
			Parse.Cloud.run("getallusers", params ).then(function(result) {
				var users = result.map(item => { return { username: item.attributes.username, id: item.id, supercategory: item.attributes.supercategory} });
				self.$el.html(handlebarsTemplate({users: users}));
				self.closeContacts();
				Parse.Cloud.run("getUnreadMessages", {"id": Parse.User.current().id}).then(function(results) {
					for(var i=0; i < results.length; i++){
						var chatId = results[i].objectId;
						self.getNotified(chatId);
					}
				});
			},
			function(error) {
				console.log(error);
				switch(error.code){
					case 100:
						toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
					break;
				}
			});
			this.subscribeLQ();
		}
	},
	
    subscribeLQ: async function(){
		let query = new Parse.Query('ChatMessages');
		var userPointer = { __type: 'Pointer', className: '_User', objectId: Parse.User.current().id };
		query.equalTo('receiver', userPointer);
		let subscription = await query.subscribe();
		subscription.on('create', (object) => {
			this.updateChat(object);
		},
		(error) => {
			console.log(error);
			switch(error.code){
				case 100:
					toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
				break;
			}
		});
	},
	
	updateChat: function(object){
		var chatId = object.attributes.sender.id;
		if(this.currentChat !== undefined && this.currentChat === object.attributes.sender.id){
			this.receiveMessage(object);
			$('#minim_chat_window').addClass('minim-notification');
		}
		this.getNotified(chatId);
		$('#chat-unread').prop('checked', true);
		this.orderByUnread();
	},
	
	minim: function(){
		if (!$('#minim_chat_window').hasClass('panel-collapsed')) {
			$('#chat-container .panel-body').slideUp();
			$('#chat-container .panel-footer').slideUp();
			$('#minim_chat_window').addClass('panel-collapsed');
		}
		else {
			$('#chat-container .panel-body').slideDown();
			$('#chat-container .panel-footer').slideDown();
			$('#minim_chat_window').removeClass('panel-collapsed');
			this.chatNotificationOff();
		}
	},
	
	close: function(){
		this.handleNotifications(this.currentChat);
		$( "#chat_window_1" ).remove();
		this.currentChat = undefined;
	},

	newChat: function(e){
		var targetUsername = e.currentTarget.textContent || e.currentTarget.innerText;
		var targetUser = e.currentTarget.id;
		var that = this;
		this.chatPage = 0;
		getChatMessagesService().getConversation(targetUser, 0, CONVERSATION_LIMIT).then(function(query){
			that.currentChat = targetUser;
			var windowTemplate = Handlebars.template(chatWindowTemplate);
			$('#chat-container').empty();
			$('#chat-container').append(windowTemplate({targetName: targetUsername, targetId: targetUser}));
			if(query !== undefined && query.length > 0){
				var messageContainer = $('#chat-container .msg_container_base');
				var messageTemplate = Handlebars.template(chatMessageTemplate);
				var loadMore = '<div id="chat-load-more-container"><button id="chat-load-more">Ver anteriores</button></div>';
				messageContainer.prepend(loadMore);
				for(var i = query.length-1; i >= 0; i--){
					var isSender = query[i].attributes.sender.id === targetUser ? false : true;
					var date = query[i].createdAt.toLocaleDateString(lang + "-GB", dateOptions);
					var file = undefined;
					if(query[i].attributes.file !== undefined){
						var name = query[i].attributes.file._name;
						var title = name.substr(32,name.length-32);
						var url = query[i].attributes.file._url;
						file = {
							title: title,
							url: url
						};
					}
					messageContainer.append(messageTemplate({
						message: query[i].attributes.message,
						file: file,
						date: date,
						isSender: isSender,
						id: query[i].id,
						targetName: targetUsername
					}));
				}
				$('#chat-container .messages').linkify();
				messageContainer.scrollTop(messageContainer.prop("scrollHeight"));
				that.handleNotifications(targetUser);
			}
		},
		function(error){
			console.log(error);
			switch(error.code){
				case 100:
					toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
				break;
			}
		});
	},
	
	loadMoreMessages: function(){
		var targetUser = $('#btn-chat').data("id");
		var that = this;
		this.chatPage++;
		getChatMessagesService().getConversation(targetUser, this.chatPage, CONVERSATION_LIMIT).then(function(query){
			if(query !== undefined && query.length > 0){
				var messageContainer = $('#chat-container .msg_container_base');
				var messageTemplate = Handlebars.template(chatMessageTemplate);
				$('#chat-load-more-container').remove();
				var loadMore = '<div id="chat-load-more-container"><button id="chat-load-more">Ver anteriores</button></div>';
				for(var i = 0; i < query.length; i++){
					var isSender = query[i].attributes.sender.id === targetUser ? false : true;
					var date = query[i].createdAt.toLocaleDateString(lang + "-GB", dateOptions);
					var file = undefined;
					if(query[i].attributes.file !== undefined){
						var name = query[i].attributes.file._name;
						var title = name.substr(32,name.length-32);
						var url = query[i].attributes.file._url;
						file = {
							title: title,
							url: url
						};
					}
					messageContainer.prepend(messageTemplate({
						message: query[i].attributes.message,
						file: file,
						date: date,
						isSender: isSender,
						id: query[i].id
					}));
					$('#'+query[i].id).linkify();
				}
				messageContainer.prepend(loadMore);
			}
			else {
				$('#chat-load-more-container').remove();
			}
		},
		function(error){
			console.log(error);
			switch(error.code){
				case 100:
					toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
				break;
			}
		});
	},
	
	openContacts: function(){
		$('#chat-contacts').animate({width:'toggle'},350);
	},
	
	closeContacts: function(){
		$('#chat-contacts').animate({width:'toggle'},350);
	},
	
	searchContacts: function(){
		var filter, li, item, i, txtValue;
		filter = $('#contact-finder').val().toUpperCase();
		li = $('#chat-users li');
		for (i = 0; i < li.length; i++) {
			item = li[i].getElementsByClassName("username")[0];
			txtValue = item.textContent || item.innerText;
			if (txtValue.toUpperCase().indexOf(filter) > -1) {
				li[i].style.display = "";
			}
			else {
				li[i].style.display = "none";
			}
		}
	},
	
	sendMessageEnter: function(e){
		if(e.which == 13) {
			this.sendMessage();
		}
	},
	
	sendMessage: function(e){
		var targetUser = $('#btn-chat').data("id");
		getChatMessagesService().setChatMessage(targetUser, $('#btn-input').val(), undefined, (chatMessage) => {
			var container = $('#chat-container .msg_container_base');
			var handlebarsTemplate = Handlebars.template(chatMessageTemplate);
			var date = chatMessage.createdAt.toLocaleDateString(lang + "-GB", dateOptions);
			container.append(handlebarsTemplate({
				id: chatMessage.id,
				isSender: true,
				message: chatMessage.attributes.message,
				date: date
			}));
			$('#'+chatMessage.id).linkify();
			container.scrollTop(container.prop("scrollHeight"));
		},
		(error) => {
			console.log(error);
			switch(error.code){
				case 100:
					toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
				break;
				default:
					toastr.error(arrlang[lang]['ChatSendMessageError'],'Error');
				break;
			}
		});
		$('#btn-input').val("");
		this.chatNotificationOff();
	},
	
	receiveMessage: function(newMessage){
		var container = $('#chat-container .msg_container_base');
		var handlebarsTemplate = Handlebars.template(chatMessageTemplate);
		var date = newMessage.createdAt.toLocaleDateString(lang + "-GB", dateOptions);
		var file = undefined;
		if(newMessage.attributes.file !== undefined){
			var name = newMessage.attributes.file._name;
			var title = name.substr(32,name.length-32);
			var url = newMessage.attributes.file._url;
			file = {
				title: title,
				url: url
			};
		}
		container.append(handlebarsTemplate({
			id: newMessage.id,
			isSender: false,
			message: newMessage.attributes.message,
			file: file,
			date: date
		}));
		$('#'+newMessage.id).linkify();
		container.scrollTop(container.prop("scrollHeight"));
	},
	
    getNotified: function(chatId){
		$('.open-contacts-notification').show();
		if(!this.activeNotifications.includes(chatId)){
			$('#'+chatId+' .notification').show();
			this.activeNotifications.push(chatId);
		}
		$('.open-contacts-notification').text(this.activeNotifications.length);
		$('#open-contacts').addClass('open-contacts-animation');
	},
	
	handleNotifications: function(chatId){
		if(this.activeNotifications.includes(chatId)){
			$('#'+chatId+' .notification').hide();
			this.activeNotifications = this.activeNotifications.filter(n => n !== chatId);
			$('.open-contacts-notification').text(this.activeNotifications.length);
			getChatMessagesService().setMessagesAsRead(chatId);
		}
		if(this.activeNotifications.length === 0){
			$('.open-contacts-notification').hide();
			$('#open-contacts').removeClass('open-contacts-animation');
		}
	},
	
	chatNotificationOff: function(){
		this.handleNotifications(this.currentChat);
		$('#minim_chat_window').removeClass('minim-notification');
	},
	
	orderByUnread: function(){
		var li = $('#chat-users li');
		for (var i = 0; i < li.length; i++) {
			var checked = $('#chat-unread').prop("checked");
			if(checked){
				var id = li[i].id;
				if (this.activeNotifications.includes(id)) {
					li[i].style.display = "";
				}
				else {
					li[i].style.display = "none";
				}
			}
			else {
				li[i].style.display = "";
			}
		}
	},
	
	previsual: function (e){
		var preview = new PrevisualView({ file: e.currentTarget.getAttribute("data-url"), title: e.currentTarget.title });
		$('#chat-file-preview').empty();
		$('#chat-file-preview').append(preview.el);
		preview.render();
	},
	
	discardFile: function(e){
		e.currentTarget.parentElement.remove();
		var discard = e.currentTarget.id;
		this.files = this.files.filter(n => n._name !== discard);
		this.filesCont--;
		document.getElementById("upload-chat-files").value = "";
	},
	
	discardAll: function(){
		this.files = [];
		this.filesCont = 0;
		$('#chat-filenames').empty();
		$('#chat-modal').modal('hide');
		$('#upload-chat-files').val('');
	},
	
	getFileStream: function(file){
		var byteArray = new Uint8Array(file);
		var output = new Array(byteArray.length);
		var i = 0;
		var n = output.length;
		while (i < n) {
			output[i] = byteArray[i];
			i++;
		}
		return output;
	},
	
	uploadFile: function(e){
		if(e.target.files.length === 0){ return; }
		const maxAllowedSize = 50 * 1024 * 1024;
		if (e.target.files[0].size > maxAllowedSize) {
			toastr.info("Maximo 50 MB","Información");
			return;
		}
		var namelength = e.target.files[0].name.length;
		this.filesCont++;
		var extension = e.target.files[0].name.substring(namelength-4, namelength).toLowerCase();
		if (extension.charAt(0) != '.'){
			var extension = e.target.files[0].name.substring(namelength-5, namelength).toLowerCase();
		}
		var that = this;
		var reader = new FileReader();
		var name = 'File_'+this.filesCont+extension;
		$('#chat-filenames').fadeIn();
		$('#chat-filenames').append("<div class='action remove-report' title='Descartar archivo'> "+ name +"<i class='fa fa-trash discard-chat-file' id='"+name+"'></i><br></div>");
		var checkResize = imageResize.checkImage(extension);
		if(checkResize){
			var returnFunc = function(data){
				var b64Data = data.split('base64,')[1];
				var parseFile = new Parse.File(name, { base64: b64Data }, 'image/png');
				that.files.push(parseFile);
				$('#chat-modal').modal('show');
			};
			reader.onload = function (e) {
				imageResize.resizeImage(e.target.result, returnFunc);
			};
			reader.readAsDataURL(e.target.files[0]);
		}
		else{
			reader.onload = function (e) {
				var output = that.getFileStream(e.target.result);
				switch(extension){
					case '.pdf':
						var parseFile = new Parse.File(name, output, 'application/pdf');
					break;
					default:
						var parseFile = new Parse.File(name, output);
					break;
				}
				that.files.push(parseFile);
				$('#chat-modal').modal('show');
			};
			reader.readAsArrayBuffer(e.target.files[0]);
		}
	},
	
	saveFiles: function(){
		if(this.files.length === 0){
			toastr.info('No hay archivos para guardar',"Información");
		}
		else {
			$('#chatloadfilestext').show();
			$('#chatloadfilesspin').show();
			var targetUser = $('#btn-chat').data("id");
			getChatMessagesService().setFileMessages(targetUser, this.files, (error) => {
				console.log(error);
				switch(error.code){
					case 100:
						toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
					break;
					default:
						toastr.info('Error al enviar alguno de los archivos',"Información");
					break;
					$('#chatloadfilestext').hide();
					$('#chatloadfilesspin').hide();
					$('#chat-filenames').empty();
					document.getElementById("upload-chat-files").value = "";
				}
			},
			(list) => {
				var container = $('#chat-container .msg_container_base');
				var handlebarsTemplate = Handlebars.template(chatMessageTemplate);
				for(var i=0; i < list.length; i++){
					var date = list[i].createdAt.toLocaleDateString(lang + "-GB", dateOptions);
					var name = list[i].attributes.file._name;
					var title = name.substr(32,name.length-32);
					var url = list[i].attributes.file._url;
					container.append(handlebarsTemplate({
						id: list[i].id,
						isSender: true,
						message: undefined,
						file: {
							title: title,
							url: url
						},
						date: date
					}));
				}
				container.scrollTop(container.prop("scrollHeight"));
				$('#chatloadfilestext').hide();
				$('#chatloadfilesspin').hide();
				$('#chat-modal').modal('hide');
				$('#chat-filenames').empty();
				document.getElementById("upload-chat-files").value = "";
			});
			this.files=[];
			this.filesCont = 0;
			this.chatNotificationOff();
		}
	}
});
export default ChatView;
